import {palette} from "./styles/colorPalette/palette";

export const getSelectStyles = () => ({
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? palette.hightlightGrey : palette.white,
        color: isFocused ? palette.white : palette.hightlightGrey,
        cursor: isDisabled ? 'not-allowed' : 'default',
        ':active': {
          color: palette.white,
          backgroundColor: palette.hightlightGrey,
        },
      };
    },
    indicatorSeparator: (defaultStyles, state) => ({
      ...defaultStyles,
      width: 0,
    }),
  }
)
